import { render, staticRenderFns } from "./QzJingYingck.vue?vue&type=template&id=5df54834&scoped=true"
import script from "./QzJingYingck.vue?vue&type=script&lang=js"
export * from "./QzJingYingck.vue?vue&type=script&lang=js"
import style0 from "./QzJingYingck.vue?vue&type=style&index=0&id=5df54834&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df54834",
  null
  
)

export default component.exports